import { defineComponent as _defineComponent } from 'vue'
import CardParametrosConsulta from './components/consulta/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/consulta/ResultadoConsulta.vue';
import { ConsultaParecerStore } from '@/views/parecer/store/ConsultaParecerStore';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router/composables';

import HeaderCustom from '../components/HeaderCustom.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultaParecer',
  setup(__props) {

const route = useRoute();
const store = ConsultaParecerStore();
store.isPrivado = (route.meta?.isPrivado as boolean) ?? false;
const { totalElementos } = storeToRefs(store);

return { __sfc: true,route, store, totalElementos, CardParametrosConsulta, ResultadoConsulta, HeaderCustom }
}

})